
  module.exports = [
    {
      id: "dealOwner", // V-Model Name
      fieldName: "Deal Owner", // Field Name
    },
    {
      id: "dealName",
      fieldName: "Deal Name",
    },
    {
      id: "locationName",
      fieldName: "Location Name",
    },
    {
      id: "insuranceLead",
      fieldName: "Insurance Lead",
    },
    {
      id: "contactName",
      fieldName: "Contact Name",
    }
  ];